(function() {
  'use strict';

  var ARTICLE_SELECTOR = '.dev-guide__content';
  var TOC_LIST_SELECTOR = '#guide-toc-list';
  var MOBILE_LIST_SELECTOR = '#guide-jump-list';
  var MOBILE_TOGGLE_SELECTOR = '#guide-jump-toggle';
  var ACTIVE_CLASS = 'dev-guide-toc__link--active';
  var MOBILE_ACTIVE_CLASS = 'dev-guide__jump-to-link--active';

  function init() {
    var article = document.querySelector(ARTICLE_SELECTOR);
    if (!article) return;

    var headings = article.querySelectorAll('h2');
    if (headings.length === 0) return;

    headings.forEach(function(h, i) {
      if (!h.id) {
        h.id = 'section-' + i;
      }
    });

    var tocList = document.querySelector(TOC_LIST_SELECTOR);
    if (tocList) {
      buildTocLinks(tocList, headings, 'dev-guide-toc__link');
    }

    var mobileList = document.querySelector(MOBILE_LIST_SELECTOR);
    if (mobileList) {
      buildTocLinks(mobileList, headings, '');
    }

    var mobileToggle = document.querySelector(MOBILE_TOGGLE_SELECTOR);
    if (mobileToggle && mobileList) {
      mobileToggle.addEventListener('click', function() {
        var open = mobileList.classList.toggle('open');
        mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      }, {
        rootMargin: '-20% 0px -70% 0px'
      });

      headings.forEach(function(h) {
        observer.observe(h);
      });
    }
  }

  // The TOC is rendered server-side (see snippets/guide-toc.liquid) so that non-JS crawlers
  // can see it. If items are already present we only bind smooth-scroll; we build from
  // scratch solely as a fallback for content whose headings weren't slugified server-side.
  function buildTocLinks(container, headings, linkClass) {
    if (container.querySelector('a')) {
      bindSmoothScroll(container);
      return;
    }
    headings.forEach(function(h) {
      var li = document.createElement('li');
      if (linkClass) li.className = 'dev-guide-toc__item';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      if (linkClass) a.className = linkClass;
      li.appendChild(a);
      container.appendChild(li);
    });
    bindSmoothScroll(container);
  }

  function bindSmoothScroll(container) {
    container.querySelectorAll('a[href^="#"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var mobileList = document.querySelector(MOBILE_LIST_SELECTOR);
        if (mobileList) mobileList.classList.remove('open');
      });
    });
  }

  function setActive(id) {
    var tocLinks = document.querySelectorAll(TOC_LIST_SELECTOR + ' a');
    tocLinks.forEach(function(a) {
      if (a.getAttribute('href') === '#' + id) {
        a.classList.add(ACTIVE_CLASS);
      } else {
        a.classList.remove(ACTIVE_CLASS);
      }
    });

    var mobileLinks = document.querySelectorAll(MOBILE_LIST_SELECTOR + ' a');
    mobileLinks.forEach(function(a) {
      if (a.getAttribute('href') === '#' + id) {
        a.classList.add(MOBILE_ACTIVE_CLASS);
      } else {
        a.classList.remove(MOBILE_ACTIVE_CLASS);
      }
    });

    // Update only the label span — writing textContent on the button itself would
    // wipe out the chevron SVG.
    var label = document.querySelector(MOBILE_TOGGLE_SELECTOR + ' .dev-guide__jump-to-label');
    if (label) {
      var activeHeading = document.getElementById(id);
      if (activeHeading) label.textContent = activeHeading.textContent;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
